import {useMatches} from "react-router-dom";
import {useMemo} from "react";
import {Breadcrumbs, BreadcrumbsProps} from "../Breadcrumbs/Breadcrumbs";

export type RouteBreadcrumbsProps = Omit<BreadcrumbsProps, 'children' | 'separator'> & {}

export const RouteBreadcrumbs = (props: RouteBreadcrumbsProps) => {
  const {...rest} = props;

  const matches = useMatches();


  const crumbs = useMemo(() => {
    return matches
      .filter((match) => {
        // @ts-ignore
        return typeof match.handle?.crumb !== 'undefined'
      })
      .map((match) => {
        // @ts-ignore
        return match.handle.crumb(match.data)
      })
  }, [matches])

  return (
    <Breadcrumbs {...rest} separator=">">
      {crumbs}
    </Breadcrumbs>
  )
}
